import { cn } from '@/utils/styles/cn'

interface IRestaurantTagsProps {
    className?: string
    hideOnMobile?: boolean
    hideOnDesktop?: boolean
    style?: React.CSSProperties
}

export const SeparationLine = ({
    className,
    hideOnDesktop,
    hideOnMobile,
    style,
}: IRestaurantTagsProps) => {
    return (
        <div
            style={style}
            className={cn(
                'bg-black/40 w-[1px] md:w-[1px] min-h-[12px]',
                hideOnMobile && hideOnDesktop ? 'hidden' : '',
                hideOnMobile && !hideOnDesktop ? 'hidden md:block' : '',
                hideOnDesktop && !hideOnMobile ? 'md:hidden' : '',
                className
            )}
        />
    )
}
